import {phone} from '@/constants'
import {
  getInOrgSite,
  getIsVkApp,
  getIsVkAppContextless,
  getSourceId,
  setAppInitiator
} from '@/composables/context'
import {reactive} from '@/plugins/compositionApi'
import {API, client} from '@/services/http'
import {
  needRedirect,
  toBuyoutItemState,
  toSourceListState,
  toSourceState
} from '@/services/routing'
import {check} from '@/services/vkApi'

// const DEFAULT_REDIRECT_CALLBACK = () =>
//     window.history.replaceState({}, document.title, window.location.pathname)
const unauthCode = 401

const user = reactive({
  authorized: false,
  unauthorized: false,
  data: {},
  loading: true,
  context: null,
  error: false
})

const userProfile = reactive({
  fullName: '',
  phone: '',
  phoneCode: '',
  resolved: false
})

const _askProfile = profileId => {
  client.get(`${API.PROFILES.ITEM}?id=${profileId}`)
    .then(setUserProfile)
}

const askUser = () => {
  return client.get(API.USER.INFO)
    .then(data => {
      user.data = data
      setAppInitiator(check(user.data.context))
      if (getIsVkApp()) {
        const sourceId = user.data.context.source_id
        if (sourceId) {
          // Vk App opened from group context
          const initialBuyoutId = window.INITIAL_HASH_FROM_PATH
          if (initialBuyoutId && initialBuyoutId.length) {//to buyout
            toBuyoutItemState(sourceId, initialBuyoutId)
          } else {
            toSourceState(sourceId)
          }
        } else {
          // Vk App opened from user context
          toSourceListState()
        }
      } else if (getIsVkAppContextless()) {
        toSourceListState()
      } else if (getInOrgSite() && needRedirect()) {
        toSourceState(getSourceId())
      }

      _askProfile(data.vkInfo.profileId)
      user.authorized = true
      user.unauthorized = false
      return data
    })
    .catch(err => {
      user.authorized = false
      user.unauthorized = true
      user.context = null
      if (err.code === unauthCode) {
        user.unauthorized = true
        setAppInitiator()
      } else {
        user.error = true
      }
      throw err
    })
    .finally(() => user.loading = false)
}

const getUser = () => user
const getUserProfile = () => userProfile
const setUserProfile = data => {
  userProfile.fullName = data.fullName
  userProfile.phone = data.phone
  userProfile.phoneCode = data.phoneCode || phone.codes[0]
  userProfile.resolved = true
}
const setUserShowIntro = (show) => {
  user.data.showIntro = show
  if (!show) {
    client.post(API.USER.INTRO_SKIP)
  }
}

const enableRequiredPermissions = () => {
  if (!needPermissions()) return

  user.data.message.permissions.buyoutPayment = true
  user.data.message.permissions.buyoutDelivery = true
  client.post(API.DELIVERY.MESSAGE.PERMISSIONS.SETUP, {permissions: user.data.message.permissions})
}

const needPermissions = () => {
  return user.authorized
    && (!user.data.message.permissions.buyoutPayment || !user.data.message.permissions.buyoutDelivery)
}

export {
  askUser,
  enableRequiredPermissions,
  getUser,
  getUserProfile,
  setUserProfile,
  setUserShowIntro,
  needPermissions
}